module.exports = __webpack_public_path__ + "static/media/intro_image_mobile.533c611f.svg";